import { useQuery } from '@tanstack/react-query';
import { DocumentService } from '../../services/document';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IDocumentResponse } from '../../interfaces/documentResponse';

interface IProps extends IBaseUseQueryProps<IDocumentResponse[]> {
  customerId: number;
  revisionId: string;
}

export const useGetCustomerDocRevisions = ({ customerId, revisionId, ...props }: IProps) => useQuery({
  queryKey: ['revisions', customerId, revisionId],
  queryFn: () => DocumentService.getDocumentRevisions(customerId!, revisionId!),
  refetchOnWindowFocus: false,
  retry: 0,
  keepPreviousData: true,
  ...props
});